import { uniq } from 'lodash';

export default ['configService', 'storeService', (configService, storeService) => {

    const setGuestInputError = (errorFields, item) => {
        const genderErrors = errorFields.filter(error => error === 'gender');
        const requiredErrors = errorFields.filter(error => error === 'required');

        if (genderErrors.length === 1) {
            return `A guest has the wrong gender for this ${item.type || item.type_display}.`;
        }

        if (genderErrors.length > 1) {
            return `Several guests have the wrong gender for this ${item.type || item.type_display}.`;
        }

        if (requiredErrors.length === 1) {
            return 'A guest is missing required fields.';
        }

        if (requiredErrors.length > 1) {
            return 'Several guests are missing required fields.';
        }
    };

    const price = (guest) => {
        let prices = {
            'base': 0,
            'additionals': 0,
            'total': 0
        };

        if (guest && guest.item_details) {
            for (let item of guest.item_details) {
                if (item.item_summary && item.item_summary.price.price) {
                    prices.base += parseFloat(item.item_summary.price.price);
                }
                if (item.credit_state) {
                    for (let credit of item.credit_state) {
                        if (parseFloat(credit) > 0) {
                            prices.additionals += parseFloat(credit);
                        }
                    }
                } else if (item.item_children) {
                    for (let child of item.item_children) {
                        let price;
                        if ((child.item_type === 'App\\OptionGroupOption' ||
                            child.item_type === 'App\\EventExtra')) {
                            if (child.item_summary) {
                                price = child.item_summary.price;
                            } else {
                                price = child.price;
                            }
                            price = parseFloat(price['price']);
                            if (price > 0) prices.additionals += price;
                        }
                    }
                }
            }
        }

        prices.total = prices.base + prices.additionals;

        return prices;
    };

    const validateAdd = (item, guests, status = undefined) => {
        let guestCounter = [];
        let errorFields = [];

        if (item.available === false) {
            return 'Sorry, this event is not currently available.';
        }

        if (!item.preferred_time && !item.suggested) {
            return 'Please select your arrival time.';
        }

        if (item.phone_only || status === 1) {
            return 'Please call us to book this event.';
        }

        let property = configService.get('property');

        for (const index in guests) {
            const guest = guests[index];

            if ((!guest.integration_reference && !guest.title) || !guest.first_name || !guest.last_name || (property.hasIntegration && !guest.gender)) {
                errorFields.push('required');
                continue;
            }

            if (item.gender && item.gender !== guest.gender) {
                errorFields.push('gender');
                continue;
            }

            guestCounter.push(guest.title + guest.first_name + guest.last_name);
        }

        if (errorFields.length) {
            return setGuestInputError(errorFields, item);
        }

        if (uniq(guestCounter).length !== guests.length &&
            guestCounter.length <= item.quantity &&
            guestCounter.length >= item.minimum_guests
        ) {
            return 'You\'ve entered the same guest details more than once.';
        }

        if (guestCounter.length < item.minimum_guests) {
            return 'Too few guests added.';
        }
    };

    return {
        price,
        validateAdd
    };
}];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/basket/services/basketItem.service.js